$('[data-ga-trigger=ga-event-tracking]').click(function () 
{
    gtag('event', $(this).attr('data-ga-event-action'), 
    {
      'event_category': $(this).attr('data-ga-event-category'),
      'event_label': $(this).attr('data-ga-event-label')
  });
});

// Quiz
$('.quiz').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:true,
    prevArrow: $('.quiz__left-home'),
    nextArrow: $('.quiz__right-home'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          arrow:true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          arrow:true,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrow:true,
          dots: true
        }
      }
    ]
  });

  //Home Top Main Slider
$('.homeSliderTop').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrow:true,
  prevArrow: $('.quiz__prev'),
  nextArrow: $('.quiz__next'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrow:true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrow:true,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrow:true,
        dots: true
      }
    }
  ]
});

//UPES Star Slider
$('.upesStar-slider').slick({
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrow:true,
  nextArrow: $('.upesStar__right'),
  prevArrow: $('.upesStar__left'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrow:true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrow:true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrow:false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrow:false,
        dots: true
      }
    }
  ]
});

//Shakti Graduate
$('.ShaktiGraduate').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrow:true,
  nextArrow: $('.shaktigraduate__right'),
  prevArrow: $('.shaktigraduate__left'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrow:true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrow:true,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrow:true,
        dots: true
      }
    }
  ]
}).on('setPosition', function (event, slick) {
  slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});;



//ProgressBar
$(document).ready(function(){

  var getMax = function(){
      return $(document).height() - $(window).height();
  }

  var getValue = function(){
      return $(window).scrollTop();
  }

  if('max' in document.createElement('progress')){
      // Browser supports progress element
      var progressBar = $('progress');

      // Set the Max attr for the first time
      progressBar.attr({ max: getMax() });

      $(document).on('scroll', function(){
          // On scroll only Value attr needs to be calculated
          progressBar.attr({ value: getValue() });
      });

      $(window).resize(function(){
          // On resize, both Max/Value attr needs to be calculated
          progressBar.attr({ max: getMax(), value: getValue() });
      });
  }
  else {
      var progressBar = $('.progress-bar'),
          max = getMax(),
          value, width;

      var getWidth = function(){
          // Calculate width in percentage
          value = getValue();
          width = (value/max) * 100;
          width = width + '%';
          return width;
      }

      var setWidth = function(){
          progressBar.css({ width: getWidth() });
      }

      $(document).on('scroll', setWidth);
      $(window).on('resize', function(){
          // Need to reset the Max attr
          max = getMax();
          setWidth();
      });
  }
});


$(document).ready(function(){

$('#single').addClass("active");
$('#progressBar').addClass('single');


$('#single').on('click', function(){
  $('#progressBar').removeClass().addClass('single');
  $('a').removeClass();
  $(this).addClass('active');
  $(this).preventDefault();
});


$(document).on('scroll', function(){

    maxAttr = $('#progressBar').attr('max');
    valueAttr = $('#progressBar').attr('value');
    percentage = (valueAttr/maxAttr) * 100;

    if(percentage<49){
      document.styleSheets[0].addRule('.semantic', 'color: red');
      document.styleSheets[0].addRule('.semantic::-webkit-progress-value', 'background-color: red');
      // document.styleSheets[0].addRule('.semantic::-moz-progress-bar', 'background-color: red');
    }
    else if(percentage<98){
      document.styleSheets[0].addRule('.semantic', 'color: orange');
      document.styleSheets[0].addRule('.semantic::-webkit-progress-value', 'background-color: orange');
      // document.styleSheets[0].addRule('.semantic::-moz-progress-bar', 'background-color: orange');
    }
    else {
      document.styleSheets[0].addRule('.semantic', 'color: green');
      document.styleSheets[0].addRule('.semantic::-webkit-progress-value', 'background-color: green');
      // document.styleSheets[0].addRule('.semantic::-moz-progress-bar', 'background-color: green');
    }
});

});




$(".wq-answer").on('click', function(){
  var ansId = ($(this).attr("data-answerid"));
  var ansNo = ($(this).attr("data-answer"));
  if (ansId=="0"){
      if(ansNo=="answer1")
      {
        $("#response_b").hide();
        $("#response_c").hide();
        $("#response_a").show();
      }
      else if(ansNo=="answer3"){
        $("#response_a").hide();
        $("#response_c").show();
        $("#response_b").hide();
      }
      else if(ansNo=="answer2"){
        $("#response_a").hide();
        $("#response_b").show();
        $("#response_c").hide();
      }
      else{
        // gtag('event', $(this).attr('data-ga-event-action'), {
        //   'event_category': $(this).attr('data-ga-event-category'),
        //   'event_action': $(this).attr('data-ga-event-action'),
        //   'event_label': $(this).attr('data-ga-event-label'),
        //   'event_value': $(this).attr('data-ga-event-value')
        //   });
      }
  }

});

$('.wq_singleAnswerCtr').on('click', function(){
  $('.wq_questionAnswersCtr').fadeOut(500);
  // $('.quizAnsBox').fadeOut();
  $('.quizAnsBox').delay(500).fadeIn(1000);
});
$("#tryagain").on('click', function(){
  $('.quizAnsBox').fadeOut(500);
  $('.wq_questionAnswersCtr').delay(500).fadeIn(1000);
});


// NEW JS : VISHAL

$(document).ready(function(){

    var highestBox = 0;
    $('.school__form label .option-content').each(function(){
      if($(this).height() > highestBox) {
        highestBox = $(this).height();
      }
    });
    $('.school__form label .option-content').height(highestBox);

});



$('#btn-submit').click(function(){
  $('html, body').animate({ scrollTop: 0 }, 'fast');
})